import React from "react";
import { useParams } from "react-router-dom";
import { useWhiteLabelLead } from "@lib/context";
import { NoPermission } from "@lib/components/AppComponents";
import { SharedWalletAddressSendByteList } from "@app/shared";

const CustomerLeadWalletList: React.FC = () => {
  const { leadId } = useParams();
  const { permissions } = useWhiteLabelLead();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return <SharedWalletAddressSendByteList leadId={leadId} />;
};

export default CustomerLeadWalletList;
